"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectInstance = void 0;
const error_1 = require("../error");
const property_instance_1 = require("./property-instance");
const observers_1 = require("./observers");
const SUBJECT = Symbol('ecce-subject');
/**
 * Manages an instance of a subject.
 *
 * Owns subject's observable {@link PropertyInstance}s, and manages the
 * subject's direct observers.
 */
class SubjectInstance {
    constructor(instance, name, propertyDefs) {
        this.name = name;
        this.properties = this.initProperties(propertyDefs, instance);
        this.observers = new observers_1.Observers(name);
    }
    /**
     * Notify the subject's observers.
     */
    notify() {
        this.observers.notify();
    }
    /**
     * Add an observer to the subject.
     */
    observe(callback, options) {
        this.observers.add(callback, options);
    }
    /**
     * Remove an observer from the subject.
     */
    unobserve(callback) {
        this.observers.remove(callback);
    }
    /**
     * Get the {@link PropertyInstance} which manages the property represented by
     * `key`, or `null` if `key` is not an observable property of the subject.
     */
    getProperty(key) {
        var _a;
        return (_a = this.properties.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    initProperties(propertyDefs, instance) {
        const map = new Map();
        for (const def of propertyDefs) {
            map.set(def.key, new property_instance_1.PropertyInstance(this, def, instance));
        }
        return Object.freeze(map);
    }
    /**
     * Construct & apply a SubjectInstance to `instance`.
     */
    static apply(instance, name, propertyDefs) {
        return instance[SUBJECT] = new SubjectInstance(instance, name, propertyDefs);
    }
    /**
     * Get the SubjectInstance which manages `target`, or `null` if `target` is
     * not a subject.
     */
    static getOrNull(target) {
        var _a;
        return (_a = target[SUBJECT]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Get the SubjectInstance which manages `target`.
     *
     * @throws if `target` is not a subject.
     */
    static get(target) {
        if (!target[SUBJECT]) {
            throw new error_1.EcceError('Target is not a subject.');
        }
        return target[SUBJECT];
    }
}
exports.SubjectInstance = SubjectInstance;
//# sourceMappingURL=subject-instance.js.map